import { c as _c } from "react/compiler-runtime";
import type { ProcessedContent } from "./media-utils";
import ContentSegmentComponent from "./ContentSegmentComponent";
import MediaThumbnail from "./MediaThumbnail";
interface ContentDisplayProps {
  readonly content: ProcessedContent;
  readonly onClick?: () => void;
  readonly className?: string | undefined;
  readonly textClassName?: string | undefined;
}

/**
 * Component to display processed content with text segments and media
 */
export default function ContentDisplay(t0) {
  const $ = _c(15);
  const {
    content,
    onClick,
    className,
    textClassName
  } = t0;
  const t1 = onClick ? "tw-cursor-pointer hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out" : "";
  const t2 = className ?? "";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = ["tw-break-all tw-text-iron-300 tw-font-normal tw-text-sm tw-flex tw-items-center tw-gap-1.5 tw-line-clamp-1", t1, t2].filter(Boolean);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const containerClasses = t3.join(" ");
  const t4 = `tw-line-clamp-1 ${textClassName ?? ""}`;
  let t5;
  if ($[3] !== content.segments) {
    t5 = content.segments.map(_temp);
    $[3] = content.segments;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <span className={t4}>{t5}</span>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== content.apiMedia) {
    t7 = content.apiMedia.map(_temp2);
    $[8] = content.apiMedia;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== containerClasses || $[11] !== onClick || $[12] !== t6 || $[13] !== t7) {
    t8 = <span className={containerClasses} onClick={onClick}>{t6}{t7}</span>;
    $[10] = containerClasses;
    $[11] = onClick;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp2(media, i_0) {
  return <MediaThumbnail key={`api-media-${i_0}`} media={media} />;
}
function _temp(segment, i) {
  return <ContentSegmentComponent key={`segment-${i}`} segment={segment} index={i} />;
}